import { render, staticRenderFns } from "./taskFrom.vue?vue&type=template&id=b20962de&scoped=true"
import script from "./taskFrom.vue?vue&type=script&lang=js"
export * from "./taskFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20962de",
  null
  
)

export default component.exports